<div class="container-fluid" style="margin-bottom: 20px; padding-bottom: 20px;">
  <p-panel class="eca-card">
    <ng-template pTemplate="header" class="eca-secondary-bg" style="color: white">
      <div class="row" style="padding: 5px!important ; width:100% !important;">
        <div class="col-auto d-flex align-items-center" style="padding-right: 0 !important;">
          <div class="d-flex align-items-center">
            <h3 style="margin-bottom: 0 !important;" class="list-page-main-header">
              <span><fa-icon [icon]="['fad', 'users']"> </fa-icon> Audit History </span>
            </h3>
          </div>
        </div>
        <div class="col pull-right">
          <app-eca-ghost-btn class="card-action-icon float-right" btnIcon="question-circle" btnType="warning" (btnClicked)="openAuditHistoryHelp()"></app-eca-ghost-btn>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="content" class="eca-card-body">
      <div *ngIf="loadingAuditHistory" class="text-center">
        <fa-duotone-icon [icon]="['fad', 'spinner']" [spin]="true" [pulse]="true" size="4x" primaryColor="darkgreen"
                         secondaryColor="green"></fa-duotone-icon>
      </div>
      <div *ngIf="!loadingAuditHistory">
        <div class="container-fluid" style="padding-left: 0; padding-right: 0;">
          <div class="row">
            <div class="col">
              <p-table #auditHistoryTable [value]="auditHistory" dataKey="auditId"
                       styleClass="p-datatable-striped p-datatable-responsive-eca" [scrollable]="!isOnMobile && auditHistory.length > 5"
                       scrollHeight="500px" [responsive]="true" [columns]="columns" [totalRecords]="auditHistory?.length">
                <ng-container>
                  <ng-template pTemplate="caption" *ngIf="showTitleBar">
                    <div class="row d-flex justify-content-between align-items-center">
                      <div class=" col-xl-auto col-lg-12 col-md-12 col-sm-12">
                        <div class="row justify-content-xl-start  justify-content-lg-start justify-content-md-between justify-content-sm-between justify-content-between align-items-center">
                          <div class="col-auto">
                            <h5 class="eca-primary-text">
                              <span *ngIf="auditHistory"> {{ auditHistory.length }}</span>
                              Audit History
                            </h5>
                          </div>
                        </div>
                      </div>
                      <div class=" col-xl-auto col-lg-12 col-md-12 col-sm-12 ">
                        <div class="row justify-content-xl-end  justify-content-lg-end justify-content-md-between justify-content-sm-between justify-content-between align-items-center">
                          <div class="col-xl-auto col-lg-auto col-md-12 col-sm-12 col-12">
                            <div class="row justify-content-xl-start  justify-content-lg-start justify-content-md-between justify-content-sm-between justify-content-between align-items-center">
                              <div class="col-auto">
                                <app-eca-ghost-btn btnIcon="file-excel" btnText="Export" btnType="primary" (btnClicked)="exportToExcel()"></app-eca-ghost-btn>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </ng-container>
                <ng-template pTemplate="header">
                  <tr>
                    <th style="width: 10%" pSortableColumn="auditDate">
                      Date
                      <p-sortIcon field="auditDate"></p-sortIcon>
                    </th>
                    <th style="width: 10%" pSortableColumn="auditAction">
                      Action
                      <p-sortIcon field="auditAction"></p-sortIcon>
                    </th>
                    <th style="width: 10%" pSortableColumn="updatedBy">
                      User
                      <p-sortIcon field="updatedBy"></p-sortIcon>
                    </th>
                    <th style="width: 10%" pSortableColumn="operation">
                      Operation
                      <p-sortIcon field="operation"></p-sortIcon>
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-auditHistory let-columns="columns">
                  <tr>
                    <td *ngFor="let col of columns">
                      <span class="p-column-title">{{col.header}}: </span>
                      <label>
                        <span *ngIf="col.type=== 'text'">
                          {{ auditHistory[col.field] }}
                        </span>
                        <span *ngIf="col.type === 'date'">
                          {{ auditHistory[col.field] | date:'dd/MM/yyyy hh:mm' }}
                        </span>
                      </label>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </p-panel>
</div>
